<div class="absolute inset-0 flex flex-col min-w-0 overflow-y-auto">
    <mat-drawer-container class="flex-auto h-full" (backdropClick)="onBackdropClick()">
        <mat-drawer class="w-full sm:w-160 dark:bg-gray-900" [mode]="drawerMode()" [opened]="false" [position]="'end'"
            [disableClose]="true" #matDrawer>
            <router-outlet></router-outlet>
        </mat-drawer> 
        <mat-drawer-content #drawerContent>            
            <ng-container *ngTemplateOutlet="listComponent()">                               
            </ng-container>                 
        </mat-drawer-content>         
    </mat-drawer-container>    
</div>